import { render, staticRenderFns } from "./ModalExportNoti.vue?vue&type=template&id=0f0847a5&scoped=true"
import script from "./ModalExportNoti.vue?vue&type=script&lang=js"
export * from "./ModalExportNoti.vue?vue&type=script&lang=js"
import style0 from "./ModalExportNoti.vue?vue&type=style&index=0&id=0f0847a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0847a5",
  null
  
)

export default component.exports